<template>
  <div>
    <!-- Hamburger Icon -->
    <button
      @click="toggleMenu"
      class="relative z-50 w-8 h-8 text-gray-600 focus:outline-none"
    >
      <span class="sr-only">Open main menu</span>
      <div
        class="absolute block w-full transform -translate-x-1/2 -translate-y-1/2 left-1/2 top-1/2"
      >
        <span
          aria-hidden="true"
          class="block absolute h-0.5 w-6 bg-current transform transition duration-300 ease-in-out"
          :class="{ 'rotate-45': isOpen, '-translate-y-1': !isOpen }"
        ></span>
        <span
          aria-hidden="true"
          class="block absolute h-0.5 w-6 bg-current transform transition duration-300 ease-in-out"
          :class="{ '-rotate-45': isOpen, 'translate-y-1': !isOpen }"
        ></span>
      </div>
    </button>

    <!-- Overlay -->
    <transition name="fade">
      <div
        v-if="isOpen"
        @click="closeMenu"
        class="fixed inset-0 z-30 bg-black/40"
      ></div>
    </transition>

    <!-- Menu Panel -->
    <transition name="slide">
      <div
        v-if="isOpen"
        class="fixed top-0 right-0 z-40 w-full max-w-sm h-full bg-white shadow-lg p-8"
      >
        <nav class="mt-20 flex flex-col items-start space-y-8">
          <router-link
            to="/blog"
            @click="closeMenu"
            class="text-2xl font-semibold text-gray-800 hover:text-emerald-500 transition-colors"
          >
            Blog
          </router-link>
          <ButtonMain>
            <a
              href="https://calendly.com/rositano-tony/30-minute-meeting"
              target="_blank"
              @click="closeMenu"
            >
              Book a call
            </a>
          </ButtonMain>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import ButtonMain from "@/components/shared/ButtonMain.vue";

const isOpen = ref(false);
const route = useRoute();

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};

const closeMenu = () => {
  isOpen.value = false;
};

// Watch for route changes to close the menu
watch(
  () => route.path,
  () => {
    closeMenu();
  }
);

// Watch for the menu opening to disable body scroll
watch(isOpen, (newVal) => {
  if (newVal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
});
</script>

<style scoped>
/* Fade animation for overlay */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Slide animation for menu panel */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
</style>
